import NProgress from 'nprogress'

import router from '@/router'

NProgress.configure({
  speed: 300,
  showSpinner: false
})

router.beforeEach((to, from, next) => {
  if (to.name !== from.name) {
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  NProgress.done()
})

export default NProgress



// WEBPACK FOOTER //
// ./src/plugins/nprogress.js